import React, { useState, forwardRef, useRef } from 'react';

// material
import {styled } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import {
   Box, Grid, Typography, 

  Stack,
  Modal,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Button,
  TextField,
  Slide,

} from '@mui/material';
import { LoadingButton } from '@mui/lab';



import CloudUploadIcon from '@mui/icons-material/CloudUpload';


import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { parseValidationErrorMessage } from '../../../utils/Utilities'
import { useAuth } from '../../customContextProviders/AuthContext';
import AlertDialog from '../../AlertDialog';
import { MerchantBulkUpload, AddNewMerchant } from '../../../network/Merchants';
import { getPinCodeDetails } from '../../../network/AppLevel'






// ----------------------------------------------------------------------


/* eslint-disable */
const SlideTransition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
/* eslint-enable */

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});



const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  position: 'absolute',
  width: '100%',
  maxWidth: { sm: '90%', xs: '90%', md: 600 },
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: '70%',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const DeviceSchema = Yup.object().shape({
  merchantAddress: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),

  merchantCity: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),

  merchantCountry: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),

  merchantId: Yup.string()
    .required('Required')
    .test('no-space', 'Merchant Id should not contain spaces', (value) => !/\s/.test(value)),

  merchantKey: Yup.string()
    .required('Required')
    .test('no-space', 'Merchant Key should not contain spaces', (value) => !/\s/.test(value)),

  merchantMobileNo: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),

  merchantName: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),

  merchantPincode: Yup.string()
    .required('Required')
    .test('no-space', 'Field should not contain spaces', (value) => !/\s/.test(value)),

  merchantState: Yup.string()
    .required('Required')
    .test('not-only-whitespace', 'Field should not contain only whitespace', (value) => /\S/.test(value)),
    
  merchantVariant: Yup.string()
    .required('Required'),

  deviceRequestType: Yup.string()
    .required('Required'),
  qrString: Yup.string()
    .required('Required'),
  language: Yup.string()
    .required('Required'),

    rentCollected: Yup.string()
    .required('Required')
  

});





export default function NewDeviceRequestFormModal({ organizationData, opneAssignedModal, handleClose }) {

  const { sessionUserData,audioCubeAppLevelSettings } = useAuth()
  const fileInputRef = useRef(null);


  const [selectedVehicleType, setSelectedVehicleType] = useState('');
  const [deviceLocation, setDeviceLocation] = useState("")
  const [deviceId, setDeviceId] = useState("")

  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });

  const [coupons, setCoupons] = useState("");
  const [deviceRequestType, setDeviceRequestType] = useState("NEW");
  const [rentCollected, setRentCollected] = useState("YES")

  const [merchantAddress, setMerchantAddress] = useState("")
  const [merchantCity, setMerchantCity] = useState("")
  const [merchantCountry, setMerchantCountry] = useState("")
  const [merchantState, setMerchantState] = useState("")
  const [merchantId, setMerchantId] = useState("")
  const [merchantKey, setMerchantKey] = useState("")
  const [merchantMobileNo, setMerchantMobileNo] = useState("")
  const [merchantName, setMerchantName] = useState("")
  const [merchantPincode, setMerchantPincode] = useState("")
  const [merchantVariant, setMerchantVariant] = useState("")
  const [qrString, setQrString] = useState("")
  const [language, setLanguage] = useState("")



  const handleVehicleTypeChange = (event) => {
    setSelectedVehicleType(event.target.value);
  };

  const [soundboxDeviceList, setSoundboxDeviceList] = useState([]);



  const addDeviceFormik = useFormik({
    initialValues: {
      merchantAddress: "",
      merchantCity: "",
      merchantCountry: "",
      merchantId: "",
      merchantKey: "",
      merchantSecretKey: "",
      merchantUpiId: "",
      ifsc: "",
      merchantMobileNo: "",
      merchantName: "",
      merchantPincode: "",
      merchantState: "",
      merchantVariant: "",
      coupons: "",
      qrString: "",
      rentCollected: "YES",
      deviceRequestType: "NEW",
      language: ""
    },
    validationSchema: DeviceSchema,
    onSubmit: () => {

      AddNewMerchant(addDeviceFormik.values?.merchantName, addDeviceFormik.values?.merchantMobileNo, addDeviceFormik.values?.merchantUpiId,
        organizationData?.id !== undefined && organizationData?.id !== null ? organizationData?.id : sessionUserData?.user?.organization?.id,
         addDeviceFormik?.values?.ifsc, addDeviceFormik?.values?.deviceRequestType,
        addDeviceFormik?.values?.qrString, addDeviceFormik?.values?.language, addDeviceFormik?.values?.merchantVariant,
        addDeviceFormik?.values?.rentCollected, addDeviceFormik?.values?.coupons, addDeviceFormik?.values?.merchantId,
        addDeviceFormik?.values?.merchantKey, addDeviceFormik?.values?.merchantCity, addDeviceFormik?.values?.merchantState,
        addDeviceFormik?.values?.merchantAddress, addDeviceFormik?.values?.merchantPincode, ""
      ).then((res) => {
          addDeviceFormik.setSubmitting(false)
        handleClose()
        setAlertDialogMetas({ ...alertDialogMetas, message: "Merchant has been successfully on-boarded", title: "Merchant On-boarded", btnLabel: "OK" });
        setOpenAlertDialog(true)

      }).catch((error) => {
        addDeviceFormik.setSubmitting(false)

        setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Failed to process your request", btnLabel: "OK" });
        setOpenAlertDialog(true)

      })

      // formik.isSubmitting=true
      // addNewMerchant(organzationClientId, addDeviceFormik.values?.merchantKey, addDeviceFormik.values?.merchantName,
      //   addDeviceFormik.values?.merchantMobileNo, addDeviceFormik.values?.merchantId, addDeviceFormik.values?.qrString, addDeviceFormik.values?.language)

    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addDeviceFormik;


  const handleCouponsChnage = (event) => {
    setCoupons(event?.target?.value)
  }

  const handleDeviceRequestTypeChangeVal = (event) => {
    setDeviceRequestType(event?.target?.value)
  }
  const handlerentCollectedChangeVal = (event) => {
    setRentCollected(event?.target?.value)
  }




  const handleFileUpload = (event) => {

    const file = event?.target?.files[0];

    if (file) {
      if (file.type !== 'text/csv') {

        event.target.value = '';
        setAlertDialogMetas({ ...alertDialogMetas, message: "Only CSV files are supported !", title: "Invalid file format", btnLabel: "OK" });
        setOpenAlertDialog(true)

      } else {
        
        addDeviceFormik.setSubmitting(true)

        MerchantBulkUpload(event.target.files[0],
          organizationData !== undefined && organizationData !== null ? organizationData?.id : sessionUserData?.user?.organizationId
        ).then((res) => {
          addDeviceFormik.setSubmitting(false)
    
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setAlertDialogMetas({ ...alertDialogMetas, message: "Merchants have been successfully created !", title: "Processed Successfully", btnLabel: "OK" });
          setOpenAlertDialog(true)
    
        }).catch((error) => {
          addDeviceFormik.setSubmitting(false)
    
          if (fileInputRef.current) {
            fileInputRef.current.value = null;
          }
          setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(error), title: "Error processing the file", btnLabel: "OK" });
          setOpenAlertDialog(true)
    
        })
      }
    }


   
  }

  const handlePincodeChange = (event) => {

    if (event?.target?.value.length === 6) {
      getPinCodeDetails(event?.target.value).then((res) => {
        try {
          if (res?.data.length > 0)
            if (res?.data[0].PostOffice.length > 0) {
              addDeviceFormik.setFieldValue('merchantCountry', res?.data[0]?.PostOffice[0]?.Country)
              addDeviceFormik.setFieldValue('merchantCity', res?.data[0]?.PostOffice[0]?.District)
              addDeviceFormik.setFieldValue('merchantState', res?.data[0]?.PostOffice[0]?.State)
            }

        } catch {
          setAlertDialogMetas({ ...alertDialogMetas, message: "Error fetching pincode details", title: "Error", btnLabel: "OK" });
          setOpenAlertDialog(true)
        }


      }).catch((error) => {

      })
    }

  }




  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        components={{ Transition: SlideTransition }}

        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        data-testid='new-merchant-request'
      >



        <FormikProvider value={addDeviceFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={{ 
            ...style, 
            maxHeight: '90vh', // 90% of the viewport height
            width: '100%', 
            overflow: 'hidden', 
            display: 'flex', 
            flexDirection: 'column',
            overflowY: 'auto'
          }}>
              <Typography sx={{ fontSize: 18, fontWeight: 900 }}>New Assign Request </Typography>


              <Grid container spacing={2} sx={{ mt: 3 }}>
              {process.env.REACT_APP_ENVIRONMENT !== "common_dashboard" && (

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <InputLabel id="device-request-label">Device Request</InputLabel>
                    <Select
                      labelId="device-request-label"
                      id="device-request-select"
                      value={deviceRequestType}
                      label="Device Request"
                      size='large'
                      onChange={handleDeviceRequestTypeChangeVal}
                      {...getFieldProps('deviceRequestType')}
                      error={Boolean(touched.deviceRequestType && errors.deviceRequestType)}
                      helperText={touched.deviceRequestType && errors.deviceRequestType}
                    >
                      <MenuItem value="NEW" sx={{ p: 1.5 }}>New</MenuItem>
                      <MenuItem value="OLD" sx={{ p: 1.5 }}>OLD</MenuItem>

                    </Select>
                  </FormControl>
                </Grid>

              )}

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantId}
                      {...getFieldProps('merchantId')}
                      error={Boolean(touched.merchantId && errors.merchantId)}
                      helperText={touched.merchantId && errors.merchantId}
                      label="Merchant Id" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantKey}
                      {...getFieldProps('merchantKey')}
                      error={Boolean(touched.merchantKey && errors.merchantKey)}
                      helperText={touched.merchantKey && errors.merchantKey}
                      label="Merchant Key" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantName}
                      {...getFieldProps('merchantName')}
                      error={Boolean(touched.merchantName && errors.merchantName)}
                      helperText={touched.merchantName && errors.merchantName}
                      label="Merchant Name" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={addDeviceFormik?.values?.merchantPincode}
                      {...getFieldProps('merchantPincode')}
                      error={Boolean(touched.merchantPincode && errors.merchantPincode)}
                      helperText={touched.merchantPincode && errors.merchantPincode}
                      onChange={e => {
                        addDeviceFormik.handleChange(e)
                        handlePincodeChange(e)
                      }}

                      label="Merchant Pincode" />
                  </FormControl>
                </Grid>


                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantCity}
                      {...getFieldProps('merchantCity')}
                      error={Boolean(touched.merchantCity && errors.merchantCity)}
                      helperText={touched.merchantCity && errors.merchantCity}
                      label="Merchant City" />
                  </FormControl>

                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantState}
                      {...getFieldProps('merchantState')}
                      error={Boolean(touched.merchantState && errors.merchantState)}
                      helperText={touched.merchantState && errors.merchantState}

                      label="Merchant State" />
                  </FormControl>

                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantCountry}
                      {...getFieldProps('merchantCountry')}
                      error={Boolean(touched.merchantCountry && errors.merchantCountry)}
                      helperText={touched.merchantCountry && errors.merchantCountry}
                      label="Merchant Country" />
                  </FormControl>
                </Grid>

              {process.env.REACT_APP_ENVIRONMENT !== "common_dashboard" && (
                  <>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <InputLabel id="device-request-label">Rent to be collected</InputLabel>
                    <Select
                      labelId="device-request-label"
                      id="device-request-select"
                      value={rentCollected}
                      label="Rent to be collected"
                      onChange={handlerentCollectedChangeVal}
                      {...getFieldProps('rentCollected')}
                      error={Boolean(touched.rentCollected && errors.rentCollected)}
                      helperText={touched.rentCollected && errors.rentCollected}>

                      <MenuItem value="YES" sx={{ p: 1.5 }}>Yes</MenuItem>
                      <MenuItem value="NO" sx={{ p: 1.5 }}>No</MenuItem>

                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <InputLabel id="device-request-label">Campaign Coupons</InputLabel>
                    <Select
                      labelId="device-request-label"
                      id="device-request-select"
                      value={coupons}
                      label="Campaign Coupons"
                      onChange={handleCouponsChnage}
                      {...getFieldProps('coupons')}
                      error={Boolean(touched.coupons && errors.coupons)}
                      helperText={touched.coupons && errors.coupons}>

                      <MenuItem value="WAIVER_CODE_1" sx={{ p: 1.5 }}>BOB Loan Campaign 10% off</MenuItem>
                      <MenuItem value="WAIVER_CODE_2" sx={{ p: 1.5 }}> Diwali Campaign 25% off</MenuItem>

                    </Select>
                  </FormControl>
                </Grid>
                </>

                )}
                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantMobileNo}
                      {...getFieldProps('merchantMobileNo')}
                      error={Boolean(touched.merchantMobileNo && errors.merchantMobileNo)}
                      helperText={touched.merchantMobileNo && errors.merchantMobileNo}

                      label="Merchant Mobile No" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={addDeviceFormik?.values?.merchantUpiId}
                      onChange={addDeviceFormik?.handleChange}
                      {...getFieldProps('merchantUpiId')}
                      error={Boolean(touched.merchantUpiId && errors.merchantUpiId)}
                      helperText={touched.merchantUpiId && errors.merchantUpiId}
                      label="Merchant UPI Id" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={qrString}
                      {...getFieldProps('qrString')}
                      error={Boolean(touched.qrString && errors.qrString)}
                      helperText={touched.qrString && errors.qrString}
                      multiline maxRows={4} label="QR String" />
                  </FormControl>
                </Grid>
              



                {/* <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={addDeviceFormik?.values?.unique_ref_no}
                      onChange={addDeviceFormik?.handleChange}
                      {...getFieldProps('unique_ref_no')}
                      error={Boolean(touched.unique_ref_no && errors.unique_ref_no)}
                      helperText={touched.unique_ref_no && errors.unique_ref_no}
                      label="Unique Ref No" />
                  </FormControl>
                </Grid> */}

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={addDeviceFormik?.values?.ifsc}
                      onChange={addDeviceFormik?.handleChange}
                      {...getFieldProps('ifsc')}
                      error={Boolean(touched.ifsc && errors.ifsc)}
                      helperText={touched.ifsc && errors.ifsc}
                      label="IFSC Code" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <TextField
                      value={merchantAddress}
                      {...getFieldProps('merchantAddress')}
                      error={Boolean(touched.merchantAddress && errors.merchantAddress)}
                      helperText={touched.merchantAddress && errors.merchantAddress}
                      multiline
                      maxRows={4}
                      label="Merchant Address" />
                  </FormControl>

                </Grid>





                <Grid item xs={12} sm={6} md={4}>

                  {
                    audioCubeAppLevelSettings?.language!==null && audioCubeAppLevelSettings?.language!==undefined && 
                    Object.keys(audioCubeAppLevelSettings?.language).length !== 0 ?
                  
                  
                  <FormControl fullWidth  >
                    <InputLabel id="device-language">Language</InputLabel>
                    <Select
                      labelId="device-language"
                      id="device-language-select"
                      value={language}
                      label="Language"
                      {...getFieldProps('language')}
                      error={Boolean(touched.language && errors.language)}
                      helperText={touched.language && errors.language}
                    >

                  {
                    Object.entries(audioCubeAppLevelSettings?.language)?.map(([key, value])=>(
                      <MenuItem value={key} key={key} sx={{ p: 1.5 }}>{value}</MenuItem>
                    ))
                  }
                    

                    </Select>
                  </FormControl>
                  :
                  null

                    }

                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                  <FormControl fullWidth  >
                    <InputLabel id="device-variant">Variant</InputLabel>
                    <Select
                      labelId="device-variant"
                      id="device-variant-select"
                      value={merchantVariant}
                      label="Variant"
                      {...getFieldProps('merchantVariant')}
                      error={Boolean(touched.merchantVariant && errors.merchantVariant)}
                      helperText={touched.merchantVariant && errors.merchantVariant}
                    >
                      <MenuItem value="audiocube_with_display" sx={{ p: 1.5 }}>AudioCube With Display</MenuItem>
                      <MenuItem value="audiocube_without_display" sx={{ p: 1.5 }}>AudioCube Without Display</MenuItem>
                      <MenuItem value="audiocube_with_qr" sx={{ p: 1.5 }}>AudioCube With Dynamic QR</MenuItem>


                    </Select>
                  </FormControl>

                </Grid>
              

              </Grid>



              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={1}
                sx={{ mt: 3, width: '100%' }}
              >


                <Stack
                  direction="row"
                  justifyContent="flex-start"
                  alignItems="center"
                  spacing={3}
                  sx={{ mt: 2, }}
                >
                  <LoadingButton loading={addDeviceFormik?.isSubmitting} sx={{fontSize: {xs: '12px', sm: 'auto', md: 'auto'}}} component="label" variant="contained" startIcon={<CloudUploadIcon />}>
                    Bulk Upload
                    <VisuallyHiddenInput ref={fileInputRef} onChange={handleFileUpload} type="file" accept='.csv' />
                  </LoadingButton>

                 



                  {/* <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'black' }}>Device in Stock :</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'red', pl: 1 }}>---</Typography>
                  </Box>
                  <Box sx={{ display: 'flex' }}>
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'black' }}>Device in Production : </Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 800, color: 'red', pl: 1 }}>---</Typography>
                  </Box> */}

                </Stack>

                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  spacing={1}
                  sx={{ mt: 3 }}
                >
                  <Button variant="contained" color="error" onClick={handleClose} >Cancel</Button>
                  <LoadingButton loading={addDeviceFormik.isSubmitting} variant="contained" color="info" type='submit' >Save</LoadingButton>
                </Stack>

              </Stack>



            </Box>
          </Form>
        </FormikProvider>


      </Modal>

      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

    </Box>
  );
}
